<template>
  <div class="qualifications__item container">
    <div class="is-registred-on-tour">
      <SimpleTooltip v-if="registred">
        <div class="check-wrap">
          <SvgIcon size="14" name="check" />
        </div>
        <template v-slot:tooltip>
          Вы зарегистрированы<br />на <b>квалификацию</b>
        </template>
      </SimpleTooltip>
    </div>
    <div class="layout row wrap">
      <div class="flex xs12">
        <div class="label">Название квалификации</div>
        <div class="info ellipsis">{{ item.name }}</div>
      </div>
      <div class="flex xs6">
        <div class="label">Регистрация с</div>
        <div class="info ellipsis">
          {{ item.registration_starts_at | dayjs("DD.MM.YYYY") }}
        </div>
      </div>
      <div class="flex xs6">
        <div class="label">Участники</div>
        <div class="info ellipsis">
          {{ item.players_count }} / {{ item.players_limit }}
        </div>
      </div>
      <div class="flex xs6">
        <div class="label">Начало</div>
        <div class="info ellipsis">
          {{ item.starts_at | dayjs("DD.MM.YYYY") }}
        </div>
      </div>
      <div class="flex xs6">
        <div class="label">Время</div>
        <div class="info ellipsis">
          {{ item.starts_at | dayjs("HH:mm") }}
        </div>
      </div>
      <div class="flex xs12 text-xs-center">
        <app-btn
          :to="`/tournament/${item.id}`"
          color="yellow-grad"
          border="bottom"
          @click="$app.metrics('click-tournament-details')"
          >Подробнее</app-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import SimpleTooltip from "@/components/ui/tooltip/SimpleTooltip";

export default {
  name: "HomeTournamentItem",
  components: {
    SimpleTooltip
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    registred: Boolean
  }
};
</script>
